export enum DatePickerSize {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum CalendarView {
  Days = 'days',
  Months = 'months',
  Years = 'years',
}

export const OVERFLOW_PADDING = 20;
export const DEFAULT_DATE_FORMAT = 'EEE, MMM d';
export const DEFAULT_PLACEHOLDER = 'Select Date';
export const TODAY_DAY_CLASS = 'dp-day-today';
